import Vue from 'vue';

const maxHistoryLength = 50;

export default {
  namespaced: true,
  state() {
    return {
      history: [],
      scrollPositions: {}, // Store scroll positions by route fullPath
      isBackNavigation: false,
    };
  },
  mutations: {
    pushToHistory(state, payload) {
      state.history.push(payload);

      if (state.history.length > maxHistoryLength) {
        state.history = state.history.slice(-maxHistoryLength);
      }
    },
    saveScrollPosition(state, { fullPath, position }) {
      state.scrollPositions = {
        ...state.scrollPositions,
        [fullPath]: position,
      };
    },
    setIsBackNavigation(state, value) {
      state.isBackNavigation = value;
    },
  },
  actions: {
    back(context, { routes = [], fallback = '/' }) {
      // Mark that we're performing a back navigation
      context.commit('setIsBackNavigation', true);

      // Find the target path from history
      const path = context.state.history.findLast(route => routes.includes(route.name))?.fullPath || fallback;

      // Navigate
      Vue.router.push(path);

      // Reset the flag after a delay
      setTimeout(() => {
        context.commit('setIsBackNavigation', false);
      }, 100);
    },
    saveCurrentScrollPosition(context, route) {
      if (!route || !route.fullPath) return;

      const position = {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop,
      };

      context.commit('saveScrollPosition', {
        fullPath: route.fullPath,
        position,
      });
    },
  },
  getters: {
    getScrollPosition: state => fullPath => state.scrollPositions[fullPath] || null,
    isBackNavigation: state => state.isBackNavigation,
  },
};
